export default __webpack_public_path__ + "static/media/AmadeuS.b52643cc.png";